import { Context } from 'Context/Context'
import React, { useContext, useEffect, useState } from 'react'

function CasePendingInfoOnProfContent({caseDetails, reqRevCountArr, userInfo}) {
    const [seeIfreqRevCountArr, setSeeIfreqRevCountArr] = useState(null);
    const getCloseCaseMessage = (fromUser, toUser, caseDetails, isCaseClosed) => {
        //who req to close case and if the one who requested is a funder or attorney

        const requester = caseDetails?.userId === toUser?._id ? toUser : fromUser;
        const partner = requester._id === toUser._id ? fromUser : toUser;

        const isRequesterFunder = requester?.isUserFunder;
        const isLoggedInRequester = requester?._id === userInfo?._id;

        console.log("requester, partner, isRequesterFunder, isLoggedInRequester", requester.email, partner.email, isRequesterFunder, isLoggedInRequester);

        if (isLoggedInRequester) {
            // Logged-in user is the one who requested to close the case
            const partnerRole = isRequesterFunder ? "attorney" : "litigation funding";
            if(isCaseClosed)
            {
              return `You closed this case with your ${partnerRole} partner ${partner?.firstName} ${partner?.lastName} from ${partner?.company}.`
            }
            else
            {
              return `You requested to close this case with your ${partnerRole} partner ${partner?.firstName} ${partner?.lastName} from ${partner?.company}.`;
            }
        } else {
            // Logged-in user is the partner of the one who requested
            const requesterRole = isRequesterFunder ? "litigation funding" : "attorney";
            const requesterNameOrCompany = isRequesterFunder
            ? requester?.company
            : `${requester?.firstName} ${requester?.lastName} from ${requester?.company}`;
            if(isCaseClosed)
            {
              return `Your ${requesterRole} partner ${requesterNameOrCompany} has closed this case.`;
            }
            else
            {
            return `Your ${requesterRole} partner ${requesterNameOrCompany} has requested to close.`;
            }
        }
        };

        const getCaseStatusMessage = () => {
            if (caseDetails?.caseStatus === "closed") {
                if (caseDetails?.teamupFromUser && caseDetails?.teamupToUser?._id) 
                  {
                    return getCloseCaseMessage (caseDetails?.teamupFromUser, caseDetails?.teamupToUser, caseDetails, true);
                  }
                  else
                  {
                    return "Case is Closed";  
                  }
                } else if (caseDetails?.caseStatus === "reqToClose") 
                  {
                    if (caseDetails?.teamupFromUser && caseDetails?.teamupToUser?._id)
                      {
                        return getCloseCaseMessage (caseDetails?.teamupFromUser, caseDetails?.teamupToUser, caseDetails);
                      }
                      else
                      {
                        return "You requested to close this case and your request to close is pending to be approved by the client.";  
                      }
                } else {
                if (seeIfreqRevCountArr) {

                    return "Another attorney requested to close this case and the request to close is pending to be approved by the client.";
                }
                else {
                    return "Case is open";
                }
            }
        }
    useEffect(() => {
      setSeeIfreqRevCountArr(reqRevCountArr?.[caseDetails?.caseDetails?._id]?.reqToClose);
    }, [reqRevCountArr])
  return (
    <>
    <div>

    </div>
    {
        caseDetails &&

        <div className='mb-4'>
            <div
            className=' lg:w-max p-2 rounded  border bg-gray-100'>
           <b>Case Status</b>: { " "}{getCaseStatusMessage()}
        </div>
        </div>

    }
    </>
    
  )
}

export default CasePendingInfoOnProfContent